'use strict';

module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/chart.js/src/charts/Chart.PolarArea.js
// module id = ../../../../chart.js/src/charts/Chart.PolarArea.js
// module chunks = 3